function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeaderCarousel.css';
import React, { useState } from 'react';
import { get, getDictionaryItem } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import HeaderMedia from '../57_HeaderMedia/HeaderMedia';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import NoDataSource from '../atoms/NoDataSource';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
const HeaderCarousel = _ref => {
  let {
    fields,
    params,
    rendering
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const hasItems = Boolean(get(fields, 'data.item.children.length'));
  const dictionary = get(fields, 'data.dictionary');
  const darkModeTitle = getDictionaryItem(dictionary, 'dark mode') || '';
  const carousalRef = React.useRef();
  const darkMode = get(sitecoreContext, 'darkMode');
  const actions = get(sitecoreContext, 'actions', {});
  const {
    changeThemeFunction = () => {}
  } = actions;
  const [carouselAutoplay, setCarouselAutoplay] = useState(true);
  const [iconplay, setIconPlay] = React.useState(true);
  const [activeBannerTitle, setActiveBannerTitle] = React.useState('');
  const [isTablet, setIsTablet] = React.useState(false);
  const carouselSpeed = get(params, 'timeout');
  const timing = carouselSpeed ? Number(carouselSpeed) * 1000 : 7000;
  const variables = {
    '--m113-interactive-banner-timing': `${timing / 1000}s`,
    '--m113-interactive-banner-half-timing': `${timing / 1000 / 2}s`
  };
  const [carouselEvent, setCarouselEvent] = React.useState('');
  React.useEffect(() => {
    if (carousalRef.current) {
      carousalRef.current.classList.remove('height-fix');
    }
  }, []);
  if (rendering && !rendering.dataSource) {
    console.info('HeaderCarousel component render skipped. No dataSource provided');
    return pageEditing ? /*#__PURE__*/React.createElement(NoDataSource, {
      title: rendering.componentName
    }) : null;
  }
  if (!fields || !hasItems) {
    console.info('HeaderCarousel component render skipped. No fields provided');
    return pageEditing ? /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [HeaderCarousel component is empty: please provide data source]") : null;
  }
  const {
    nextPrevAnalytics,
    navBubblesAnalytics,
    mobileSlidesAnalytics,
    videoAnalytics
  } = fields.data;
  const analyticsParams = {
    eventName: params.eventName,
    eventCat: params.eventCat,
    eventAct: params.eventAct
  };
  const items = get(fields, 'data.item.children');
  const isSecondaryCarousel = Boolean(params && params.mediaSize === 'Secondary');
  const renderItems = () => {
    return items.map(item => /*#__PURE__*/React.createElement(HeaderMedia, {
      key: item.image.jss.value.src,
      fields: {
        data: {
          item: item,
          videoAnalytics: videoAnalytics
        }
      },
      params: _objectSpread({}, params),
      carouselEvent: carouselEvent,
      getCarouselAutoplay: value => {
        console.log('setCarouselAutoplay', carouselAutoplay);
        setIconPlay(value);
        setCarouselAutoplay(value);
      },
      isSharedStyles: isSharedCh
    }));
  };
  console.log('test', carouselAutoplay);
  const handleSetActiveItem = state => {
    if (items[state.currentSlide]) {
      // const currentSlideTitle = items[state.currentSlide].title.jss.value;
      // setActiveBannerTitle(currentSlideTitle);
    }
  };
  const mergeSlideAction = () => {
    setCarouselEvent(`slide ${Math.floor(Math.random() * 101)}`);
    tealiumClickFunc(tealiumMergeClickData(mobileSlidesAnalytics, params));
  };
  const handleAutoPlay = () => {
    setCarouselAutoplay(a => !a);
    setIconPlay(a => !a);
    // tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [
    //   `${carouselAutoplay ? 'pause' : 'play'}`,
    //   activeBannerTitle,
    // ]);
  };
  const autoplayBtn = () => {
    return items.length > 1 || get(items[0], 'video.jss.value.href', '') ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `m113-interactive-banner__autoplay ${items.length === 1 && get(items[0], 'video.jss.value.href', '') && 'autoplaySingle'} ${!iconplay && 'paused'} ${isTablet ? 'tablet' : ''}`,
      onClick: () => {
        // setVideoTeaserAutoPlay(!videoTeaserAutoPlay);
        handleAutoPlay();
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: `icon ${!iconplay && 'paused'}`
    }), iconplay ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      id: "halfclip"
    }, /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "clipped"
    })), /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "fixed"
    })) : /*#__PURE__*/React.createElement(React.Fragment, null))) : /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  const commonStyleVar = !isSharedCh ? commonStyle : "c1wenh3u";
  const rtlStylesVar = !isSharedCh ? rtlStyles : "r1x2l1pc";
  const ltrStylesVar = !isSharedCh ? ltrStyles : "l1w9d3zn";
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyleVar} ${rtl ? rtlStylesVar : ltrStylesVar} header-carousel`,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "global-carousel-container height-fix",
    ref: carousalRef
  }, params && params['Dark Mode Switcher Show'] ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-7"
  }, /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), _objectSpread({
      responsive: isSecondaryCarousel ? {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1024
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      } : {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      }
    }, isSharedCh && {
      autoPlay: carouselAutoplay,
      autoPlaySpeed: timing,
      pauseOnHover: false,
      infinite: items.length !== 1
    }), () => mergeSlideAction()), isSharedCh ? /*#__PURE__*/React.createElement(React.Fragment, null, items.length === 1 ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("div", {
      className: `m113-interactive-banner__carousel__controls-sec ${rtl ? 'btn-group-rtl' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-left"
    }, renderPreviousButton(() => {
      if (carouselAutoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      setCarouselEvent(`prev ${Math.floor(Math.random() * 101)}`);
      tealiumClickFunc.bind(null, tealiumMergeClickData(nextPrevAnalytics, analyticsParams));
    }, false, true, null, false, true)), autoplayBtn(), /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner___pagination-dots"
    }, renderDots(() => {
      if (carouselAutoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      setCarouselEvent(`dots ${Math.floor(Math.random() * 101)}`);
      tealiumClickFunc.bind(null, tealiumMergeClickData(navBubblesAnalytics, analyticsParams));
    })), /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-right"
    }, renderNextButton(() => {
      if (carouselAutoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      setCarouselEvent(`next ${Math.floor(Math.random() * 101)}`);
      tealiumClickFunc.bind(null, tealiumMergeClickData(nextPrevAnalytics, analyticsParams));
    }, false, true, null, false, true)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `header-bb__controls-sec ${rtl ? 'btn-group-rtl' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-icon-white header-bb__controls d-none d-md-block"
    }, renderPreviousButton(() => {
      setCarouselEvent(`prev ${Math.floor(Math.random() * 101)}`);
      tealiumClickFunc.bind(null, tealiumMergeClickData(nextPrevAnalytics, analyticsParams));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-icon-white header-bb__controls d-none d-md-block"
    }, renderNextButton(() => {
      setCarouselEvent(`next ${Math.floor(Math.random() * 101)}`);
      tealiumClickFunc.bind(null, tealiumMergeClickData(nextPrevAnalytics, analyticsParams));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "header__pagination-dots"
    }, renderDots(() => {
      setCarouselEvent(`dots ${Math.floor(Math.random() * 101)}`);
      tealiumClickFunc.bind(null, tealiumMergeClickData(navBubblesAnalytics, analyticsParams));
    })), ' '));
  })));
};
export const commonStyle = "cqo5x79";
const ltrStyles = "l1vd2rnr";
const rtlStyles = "riijfru";
export default HeaderCarousel;